import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { DOCUMENTS_RESERVATION_EXTENT } from '../../constants';

export const useReservationContracts = ({ groupId, reservationId }: { groupId: string; reservationId: string }) => {
    const { data: reservationsData } = useRepositorySuspenseQuery('reservations', 'getAll', {
        groupIds: [groupId],
        extent: DOCUMENTS_RESERVATION_EXTENT,
    });
    const groupReservationIds = reservationsData.reservations?.map((reservation) => reservation.id);
    const { data: reservationContractsData } = useRepositorySuspenseQuery('reservationContracts', 'getAll', {
        reservationIds: groupReservationIds,
    });
    return reservationContractsData.contracts?.filter((contract) => {
        return contract.reservationId === reservationId;
    });
};
